import { createSelector } from 'reselect';

export const downloadReportState = (state) => state.downloadReport;

export const getIsDownloadingPdf = createSelector(
  downloadReportState,
  (downloadReportState) => downloadReportState.isDownloadingPDF
);

export const getIsDownloadingExcel = createSelector(
  downloadReportState,
  (downloadReportState) => downloadReportState.isDownloadingXLS
);

export const getIsDownloadModalOpen = createSelector(
  downloadReportState,
  (downloadReportState) => downloadReportState.pdfModalOpen
);
